import moment from 'moment'
import _ from 'lodash'

/**
 * @return {string|number}
 */
function DateFormatFilter(value, format = 'll') {
  if (_.isNil(value)) {
    return ''
  }

  let time
  if (moment.isMoment(value)) {
    time = value
  } else if (_.isDate(value) || _.isNumber(value)) {
    time = moment(value)
  } else if (format === 'age' || format === 'utc') {
    time = moment.utc(String(value))
  } else {
    time = moment(String(value))
  }

  if (format === 'age') {
    const today = moment.utc().startOf('day')
    const birthday = time.startOf('day')
    return today.diff(birthday, 'years')
  } else if (format === 'diff') {
    return time.fromNow()
  }

  return format === 'utc' ? time.format('ll') : time.format(format)
}

export default DateFormatFilter
export { DateFormatFilter }
